import type { TypographyVariantType } from '@n3/css-base';

export const typographyVariants = {
  BODY01: 'body01',
  BODY02: 'body02',
  BODY_COMPACT01: 'body01-compact',
  BODY_COMPACT02: 'body02-compact',
  CODE01: 'code01',
  CODE02: 'code02',
  LABEL01: 'label01',
  LABEL02: 'label02',
  HELPER_TEXT01: 'helpertext01',
  HELPER_TEXT02: 'helpertext02',
  LEGAL01: 'legal01',
  LEGAL02: 'legal02',
  HEADING_01: 'heading-01',
  HEADING_02: 'heading-02',
  HEADING_03: 'heading-03',
  HEADING_04: 'heading-04',
  HEADING_05: 'heading-05',
  HEADING_06: 'heading-06',
  HEADING_07: 'heading-07',
  HEADING_01_COMPACT: 'heading-01-compact',
  HEADING_02_COMPACT: 'heading-02-compact',
  HEADING_03_COMPACT: 'heading-03-compact',
} satisfies Record<string, TypographyVariantType>;
